import React from 'react';
import { useSite } from '../Providers/SiteInterfaceProvider';
import { DataPreFetcher } from './DataPreFetcher';
import PDFViewerModal from './PDFViewerModal';
import { ServiceAlertManager } from './ServiceAlertManager';
import CreateThreadModal from '../../MessageCentre/Components/Modals/CreateThreadModal';

function GlobalComponents() {
	const { pDFViewerDetails, siteContactDetails, setPdfViewer, UpdateSiteContact } = useSite();

	return (
		<>
			<DataPreFetcher />
			<ServiceAlertManager />

			<PDFViewerModal isOpen={pDFViewerDetails.open} closeCallback={() => setPdfViewer(false)} />

			<CreateThreadModal
				placeholderMessage={siteContactDetails.placeholderMessage}
				readOnlyMessage={siteContactDetails.readOnlyMessage}
				defaultDepartment={siteContactDetails.departmentId}
				isOpen={siteContactDetails.open}
				closeCallback={() => UpdateSiteContact(false)}
			/>
		</>
	);
}

export { GlobalComponents };
